import { makeStyles, createStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2, 2),
    },
    contentText: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "14px",
      lineHeight: "20px",
    },
    title: {
      color: "#273A39",
      fontSize: "22px",
      lineHeight: "30px",
      fontWeight: "bold",
    },
    actionButton: {
      padding: "6px 16px",
      borderRadius: "4px",
      borderStyle: "solid",
      color: theme.palette.common.white,
      fontWeight: "bold",
      fontSize: "1rem",
      textTransform: "none",
    },
    actionsLeft: {
      alignSelf: "flex-start",
      padding: "0px 25px",
    },
  })
);
